export default "__VITE_ASSET__a16dd321__"